<template>
    <div class="chatsList">
        <template v-if="allChats.length > 0">

            <div
                v-for="(chatItem, chatIndex) in allChats"
                :key="chatIndex"
                class="chat"
                :class="{
                    active: roomId === chatItem.id,
                    single: chatItem.roomType === 'single',
                    group: chatItem.roomType === 'group'
                }"
                @click.prevent="$emit('open-chat', chatItem)"
            >
                <div class="avatarArea">
                    <template v-for="(personUid, personIndex) in chatItem.info.avatars">
                        <div
                            :key="personUid"
                            class="avatar"
                            :class="`avatar_${personIndex + 1}`"
                            :style="`background-image:url(${$store.state.allUsers[personUid].photoURL});`"
                        >
                            <MemberStatus :key="`member_status_${chatItem.id}`" v-if="chatItem.roomType === 'single'" :memberId="personUid"></MemberStatus>
                        </div>
                    </template>
                </div>
                <div class="chatInfo">
                    <p class="chatName">
                        {{ chatItem.name }}
                        <span class="time">{{ chatItem.lastMessage.time }}</span>
                    </p>
                    <p v-if="chatItem.lastMessage" class="chatLastMessage">
                        <span class="lastMsg">{{ chatItem.lastMessage.name }}: {{ chatItem.lastMessage.message }}</span>
                    </p>
                    <div class="chatNotify">
                        <div class="dot" :class="{ active: chatItem.lastMessage.seen }"></div>
                    </div>
                </div>
            </div>

        </template>
        <template v-else>
            <div v-if="searchInput === ''" class="empty large">
                <div>
                    <ion-icon name="information-circle"></ion-icon>
                    <p>No chats here yet.</p>
                </div>
            </div>
            <div v-else class="empty">
                <div>
                    <ion-icon name="search"></ion-icon>
                    <p>No chats found.</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import moment from 'moment'
import MemberStatus from '@/components/MemberStatus'

export default {
    name: 'ChatsList',
    
    props: {
        roomId: String,
        searchInput: String
    },

    components: {
        MemberStatus
    },

    computed: {
        allChats(){
            let chatItems = []
            
            // Process all chat data
            Object.keys(this.$store.state.chats).forEach(chatId => {
                let chatItem = this.$store.state.chats[chatId]

                // Only get my chats
                if(typeof chatItem.info.people[this.$store.state.currentUser.uid] === 'undefined') return

                let chatData = this.processedChatItem(chatItem, chatId)
                
                chatItems.push(chatData)
            })
            
            // Filter with Search Input
            if(typeof this.searchInput !== 'undefined'){
                chatItems = chatItems.filter(chat => {
                    return chat.searchName.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1
                })
            }

            // Sort Chats List by LastMessageTimestamp
            if(chatItems.length > 0){
                let sortedChats = chatItems.sort((a, b) => {
                    return moment.unix(b.lastMessage.timestamp) - moment.unix(a.lastMessage.timestamp)
                })

                chatItems = sortedChats
            }

            return chatItems
        }
    },

    methods: {
        processedChatItem(chatItem, chatId){
            let lastMessage = null
            let chat = {
                id: chatId,
                name: '',
                searchName: '',
                lastMessage: {
                    id: '',
                    name: '',
                    timestamp: null,
                    time: '',
                    message: '',
                    seen: true
                },
                roomType: 'single',
                info: chatItem.info,
                messages: chatItem.messages
            }

            // Last Message
            if(chatItem.info.lastMessageId){
                lastMessage = chatItem.messages[chatItem.info.lastMessageId]
            }

            if(typeof lastMessage !== 'undefined'){
                let lastMessageTimestamp = null
                let lastMessageUserTimestamp = null
                let currentTimestamp = moment()
                let diff = null
                let lastMessageTime = ''
                let lastMessageText = ''

                chat.lastMessage.id = chatItem.info.lastMessageId

                if(typeof lastMessage.message !== 'undefined'){
                    lastMessageText = lastMessage.message
                }

                if(lastMessage.timestamp){
                    lastMessageTimestamp = lastMessage.timestamp
                    lastMessageUserTimestamp = moment(lastMessage.timestamp).local()
                    diff = moment.duration(currentTimestamp.diff(lastMessageUserTimestamp))
                    lastMessageTime = lastMessageUserTimestamp.format('MMM D')
                }
                
                if(lastMessage.uid === this.$store.state.currentUser.uid){
                    chat.lastMessage.name = 'You'
                }else{
                    chat.lastMessage.name = this.$store.state.allUsers[lastMessage.uid].firstName
                }

                if(diff.asDays() <= 7){
                    lastMessageTime = lastMessageUserTimestamp.format('ddd')
                }
                if(diff.asHours() <= 24){
                    lastMessageTime = lastMessageUserTimestamp.format('h:mm a')
                }

                if(lastMessage.type === 'gif'){
                    lastMessageText = 'Sent a Gif'
                }else if(lastMessage.type === 'sticker'){
                    lastMessageText = 'Sent a Sticker'
                }else if(lastMessage.type === 'image-single'){
                    lastMessageText = 'Sent an Image'
                }else if(lastMessage.type === 'image-multiple'){
                    lastMessageText = 'Sent '+ lastMessage.total +' Images'
                }else if(lastMessage.type === 'deleted'){
                    lastMessageText = 'Removed a message'
                }

                if(lastMessage.seen){
                    if(typeof lastMessage.seen[this.$store.state.currentUser.uid] !== 'undefined'){
                        chat.lastMessage.seen = false
                    }
                }

                chat.lastMessage.message = lastMessageText
                chat.lastMessage.timestamp = lastMessageTimestamp
                chat.lastMessage.time = lastMessageTime
                chat.lastMessage.messageTimestamp = lastMessageTimestamp
            }

            // Chat Name & Avatars
            if(chatItem.info.people){
                
                let avatars = []

                Object.keys(chatItem.info.people).forEach(personKey => {
                    if(this.$store.state.currentUser.uid !== personKey){
                        if(chat.name !== '') chat.name += ', '
                        
                        chat.searchName += this.$store.state.allUsers[personKey].displayName + ' '

                        if(Object.keys(chatItem.info.people).length > 2){

                            chat.name += this.$store.state.allUsers[personKey].firstName

                        }else{
                            chat.name += this.$store.state.allUsers[personKey].displayName
                        }

                        if(avatars.length < 2){
                            avatars.push(personKey)
                        }
                    }
                })

                chat.info.avatars = avatars

                if(Object.keys(chatItem.info.people).length > 2){
                    chat.roomType = 'group'
                }
            }

            return chat
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/chat/ChatsList.vue